let _ = t => t,
  _t;
import { useEffect, useState } from 'react';
import { FirstIcon, LastIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { X_DISTANCE_FROM_SIDE } from '../constants/SidebarConstants';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import I18n from 'I18n';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledCollapseButton = styledWithTheme(TFlex)(_t || (_t = _`
  transition: all 200ms cubic-bezier(0.42, 0, 0.58, 1);
`));
const CollapseButton = ({
  onClick,
  isLocked,
  collapsed,
  position,
  showTooltip,
  collapseButtonRef
}) => {
  const {
    topOffset,
    alignment
  } = position;
  const [tooltipDisabled, setTooltipDisabled] = useState(!showTooltip);
  useEffect(() => {
    setTooltipDisabled(collapsed || !showTooltip);
  }, [collapsed, showTooltip]);
  const xOffset = collapsed || alignment === 'right' ? {
    insetInlineEnd: `${X_DISTANCE_FROM_SIDE}px`
  } : {
    insetInlineStart: `${X_DISTANCE_FROM_SIDE}px`
  };
  const onButtonClick = evt => {
    onClick();
    setTooltipDisabled(isLocked);
    evt.stopPropagation();
  };
  const tooltipText = isLocked ? I18n.text('svh-workspace-ui-lib.navigation-sidebar.collapse-button.locked') : I18n.text('svh-workspace-ui-lib.navigation-sidebar.collapse-button.hovered');
  return /*#__PURE__*/_jsx(StyledCollapseButton, {
    inlineSize: "40px",
    blockSize: "40px",
    flexDirection: "column",
    alignItems: "center",
    position: "absolute",
    insetBlockStart: topOffset > 0 ? `${topOffset}px` : undefined,
    insetInlineStart: xOffset.insetInlineStart,
    insetInlineEnd: xOffset.insetInlineEnd,
    ref: collapseButtonRef,
    children: /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipText,
      disabled: tooltipDisabled,
      children: /*#__PURE__*/_jsx(IconButton, {
        "data-test-id": "view-sidebar-collapse-button",
        use: "transparent",
        onClick: onButtonClick,
        children: isLocked ? /*#__PURE__*/_jsx(FirstIcon, {}) : /*#__PURE__*/_jsx(LastIcon, {})
      })
    })
  });
};
CollapseButton.displayName = 'CollapseButton';
export default CollapseButton;